export default __webpack_public_path__ + "static/media/film.84c1e2b2.svg";